import { ComponentClass } from 'react';
export { ComponentClass };

import { AttachmentWellProps } from './components/AttachmentWellView';
import { AttachmentWellPrintViewProps } from './components/AttachmentWellPrintView';
import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "Attachments" */ './lazyIndex')
);

// Delayed Loaded Components
export const AttachmentWellView = createLazyComponent(lazyModule, m => m.AttachmentWellView);
export { AttachmentWellProps };

export const AttachmentWellPrintView = createLazyComponent(
    lazyModule,
    m => m.AttachmentWellPrintView
);
export { AttachmentWellPrintViewProps };
